import { PanelType } from '../../../../panels/types';

export const metadataMappingPanelType: PanelType = {
  name: 'metadata-mapping',
  location: 'right',
};

